<template>
  <div>
    <div class="px-4 py-2">
      <div id="div-modal-cxc" class="d-flex justify-content-center">
        <div id="div-cxc" class="card w-100 text-center">
          <div class="card-header text-white bg-main h4">
            <div style="position: relative">
              <div class="">
                <strong>UBICACIÓN DE MEDICAMENTOS</strong>
              </div>
              <div class="btn-home-jefatura" style="right: 0; top: 0; position: absolute">
                <button type="button" class="btn btn-sm px-2" @click="returnHome">
                  <i class="fas fa-home-lg-alt"></i> Inicio
                </button>
              </div>
            </div>
          </div>
          <div class="card-body w-100">
            <div class="row">
              <!--Filtro-->
              <div class="col-md-12 py-2">
                <div class="row d-flex">
                  <div class="col-xl-5 col-lg-5 col-md-6 col-sm-12 col-xs-12 mt-1 mb-2">
                    <div class="input-group input-group-sm">
                      <span class="input-group-text col-md-4">ALMACÉN</span>
                      <v-select class="text-dark flex-grow-1" label="name" :options="dataAlmacen"
                        placeholder="- Seleccionar -" v-model="selectedAlma" :reduce="(name) => name.id"
                        @input="mtdGetData">
                        <template slot="no-options">
                          No hay Almacen para la busqueda.
                        </template>
                      </v-select>
                    </div>
                  </div>
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <div class="input-group input-group w-100">
                      <span class="input-group-text text-white bg-main"><i class="fas fa-search"></i></span>
                      <input v-model="search" type="text" class="form-control form-control" placeholder="NOMBRE" />
                    </div>
                  </div>
                   <div class="col-xl-1 col-lg-2 col-md-6 col-sm-6 col-xs-6">
                    <button class="btn btn-sm w-100 text-white w-100 py-2 bg-main" type="button"
                      :disabled="mtddisableSave" @click="saveData()">
                      <i class="fas fa-save" style="font-size: 18px"></i>&nbsp;
                      Guardar
                    </button>
                  </div>
                  <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-xs-12 mb-2">
                    <div v-if="showTable">
                      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-1"
                        v-if="checkDate && checkDate.length != 0">
                        <h6 style="font-size: 13px; margin-right: 3px">
                          Ultima fecha de Guardado:
                          {{ checkDate | formatDateTime }}
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!--Fin Filtro-->
              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-3 mb-3" id="content-timelinetable"
                v-if="showTable">
                <table id="tb-anular" class="table table-bordered border-main align-middle">
                  <thead>
                    <tr class="text-white border-white text-center" style="background: #900052; vertical-align: middle">
                      <th scope="col" class="">CODIGO</th>
                      <th scope="col">NOMBRE</th>
                      <th scope="col">MOL - COMERCIAL</th>
                      <th scope="col">PRESENT.</th>
                      <th scope="col">MARCA</th>
                      <th scope="col">LOTE</th>
                      <th scope="col">FECHA VCTO</th>
                      <th scope="col" class="">CANT.</th>
                      <th scope="col" class="">PRE. COMPRA</th>
                      <th scope="col" class="">PRE. PARTICULAR</th>
                      <th scope="col" class="">REGISTRO SANITARIO</th>
                      <th scope="col" class="">UBICACIÓN</th>
                    </tr>
                  </thead>
                  <tbody class="custom-table">
                    <tr v-if="cpData.length == 0">
                      <td class="text-center align-middle" colspan="12">
                        Sin inventario
                      </td>
                    </tr>
                    <tr v-for="movement in dataShow" :key="movement.stock_id">
                      <td class="text-center align-middle">
                        {{ movement.code }}
                      </td>
                      <td class="text-center align-middle">
                        {{ movement.subsubcategoria }}
                      </td>
                      <td class="text-center align-middle">
                        {{ movement.product }}
                      </td>
                      <td class="text-center align-middle">
                        {{ movement.presentation }}
                      </td>
                      <td class="text-center align-middle">
                        {{ movement.brand_name }}
                      </td>
                      <td class="text-center align-middle">
                        {{ movement.lote ? movement.lote.toUpperCase() : "-" }}
                      </td>
                      <td class="text-center align-middle">
                        {{ movement.date_vcto | formatDate }}
                      </td>
                      <td class="text-center align-middle">
                        {{ movement.quantity }}
                      </td>
                      <td class="text-center align-middle">
                        {{ movement.purchase }}
                      </td>
                      <td class="text-center align-middle">
                        {{ movement.particular }}
                      </td>
                      <td class="text-center align-middle">
                        {{ movement.registro }}
                      </td>
                      <td class="text-center align-middle">
                        <input type="text" class="input-p form-control form-control-sm text-center"
                          v-model="movement.ubicacion" placeholder="Ingrese ubicacion."
                          style="font-size: 10px; padding: 0.25rem 0.5rem" />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mt-3 text-center">
                <!-- paginado -->
                <div v-if="cpData.length > 0 && showTable" class="d-flex justify-content-center mb-2">
                  <nav aria-label="Page navigation example">
                    <ul class="pagination mb-1">
                      <li class="page-item">
                        <a class="page-link page" href="javascript:void(0)" @click="backPage">Anterior</a>
                      </li>
                      <li v-if="limitedStepPagination[0] != 1" class="page-item">
                        <a :class="selectPage == 1 ? 'page-link active' : 'page-link'
                          " href="javascript:void(0)" @click="selectedPage(1)">1</a>
                      </li>
                      <li v-if="limitedStepPagination[0] > 2" class="page-item disabled">
                        <span class="page-link">...</span>
                      </li>
                      <li v-for="(item, index) in limitedStepPagination" :key="index" class="page-item">
                        <a :class="selectPage == item
                            ? 'page-link active'
                            : 'page-link'
                          " href="javascript:void(0)" @click="selectedPage(item)">{{ item }}
                        </a>
                      </li>
                      <li v-if="
                        limitedStepPagination[
                        limitedStepPagination.length - 1
                        ] <
                        stepPagination.length - 1
                      " class="page-item disabled">
                        <span class="page-link">...</span>
                      </li>
                      <li v-if="
                        limitedStepPagination[
                        limitedStepPagination.length - 1
                        ] != stepPagination.length
                      " class="page-item">
                        <a :class="selectPage == limitedStepPagination.length + 2
                            ? 'page-link active'
                            : 'page-link'
                          " href="javascript:void(0)" @click="selectedPage(stepPagination.length)">{{
                          stepPagination.length }}
                        </a>
                      </li>
                      <li class="page-item">
                        <a class="page-link page" href="javascript:void(0)" @click="nextPage">Siguiente</a>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <SweetAlert :swal="swal" ref="SweetAlert" />
  </div>
</template>
<script>
import { mapActions } from "vuex";
import moment from "moment";
import SweetAlert from "@/components/shared/SweetAlert/SweetAlert.vue";
export default {
  name: "Ubicacion",
  components: {
    SweetAlert,
  },
  data() {
    return {
      swal: null,
      search: "",
      dataShow: [],
      showTable: false,
      dataIn: [],
      items: 10,
      checkDate: [],
      dataAlmacen: [],
      selectedAlma: null,
      //Pag
      page: 0,
      selectPage: 1,
      stepPagination: [],
      totalPagesToShow: 4,
      variableSave: 0,
      originalUbicaciones: {},
    };
  },
  watch: {
    selectedAlma(newVal) {
      if (newVal == null) {
        this.dataIn = [];
        this.showTable = false;
      }
    },
    selectPage() {
      this.calculateData(10);
    },
    search() {
      this.selectPage = 1;
      this.calculateData(10);
    },
  },
  computed: {
    mtddisableSave() {
      return !(this.variableSave != 0);
    },
    cpData() {
      let data = [...this.dataIn];
      if (this.search.length >= 3) {
        const query = this.search.toUpperCase();
        data = data.filter((el) => {
          return (el.subsubcategoria || "").toUpperCase().includes(query);
        });
      }
      return data;
    },
    limitedStepPagination() {
      const totalPages = this.stepPagination.length;
      const currentPage = this.selectPage;
      let startPage = 1;
      let endPage = totalPages;
      if (totalPages > this.totalPagesToShow) {
        const halfPagesToShow = Math.floor(this.totalPagesToShow / 2);
        if (currentPage > halfPagesToShow) {
          startPage = currentPage - halfPagesToShow;
          endPage = currentPage + halfPagesToShow - 1;
          if (endPage > totalPages) {
            endPage = totalPages;
            startPage = totalPages - this.totalPagesToShow + 1;
          }
        } else {
          endPage = this.totalPagesToShow;
        }
      }
      return Array.from(
        {
          length: endPage - startPage + 1,
        },
        (_, i) => startPage + i
      );
    },
  },
  created() {
    moment.locale("es");
    this.vercampus();
    this.mtdGetSave();
  },
  methods: {
    ...mapActions(["get", "post"]),
    mtdGetData: function () {
      if (this.selectedAlma == null) {
        this.$refs.SweetAlert.showWarning("Seleccione un Almacén");
      } else {
        // NOTA: ajustar el endpoint real que retorne solo productos con new_quantity > 0
        this.post({
          url: this.$store.getters.get__url + "/Inventario/verificacionUbicacion",
          token: this.$store.getters.get__token,
          params: {
            alma: this.selectedAlma,
          },
        })
          .then((response) => {
            this.dataIn = response.data;
            if (this.dataIn.length == 0) {
              this.showTable = false;
              this.variableSave = 0;
              this.$refs.SweetAlert.showWarning("Sin Datos");
            } else {
              this.showTable = true;
              this.variableSave = 1;
              this.calculateData(10);
              // snapshot de ubicaciones originales para detectar cambios luego
              this.originalUbicaciones = {};
              this.dataIn.forEach((movement) => {
                this.originalUbicaciones[movement.stock_id] =
                  movement.ubicacion ?? "";
              });
            }
          })
          .catch((errors) => {
            this.$refs.SweetAlert.showError(errors);
          });
      }
    },
    mtdGetSave: function () {
      this.get({
        url: this.$store.getters.get__url + "/Inventario/traerSave",
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.checkDate = response.data;
        })
        .catch((errors) => {
          this.$refs.SweetAlert.showError(errors);
        });
    },
    calculateData(items) {
      const data = this.cpData;
      const totalPages = Math.ceil(data.length / items);
      this.stepPagination = Array.from({ length: totalPages }, (_, i) => i + 1);
      const start = (this.selectPage - 1) * items;
      const end = start + items;
      this.dataShow = data.slice(start, end);
    },
    clearData() {
      this.dataIn = [];
      this.showTable = false;
    },
    vercampus: function () {
      this.filter = { campus_id: this.$store.getters.get__campus };
      this.get({
        url:
          this.$store.getters.get__url +
          "/Kardex/filterAlmacen/" +
          this.filter.campus_id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.dataAlmacen = response.data;
        })
        .catch((errors) => {
          this.$refs.SweetAlert.showError(errors);
        });
    },
    saveData: function () {
      // Solo se envían las filas cuya ubicación cambió respecto al snapshot original
      let dataToSave = this.dataIn
        .filter((movement) => {
          const original = this.originalUbicaciones[movement.stock_id] ?? "";
          const current = movement.ubicacion ?? "";
          return current !== original;
        })
        .map((movement) => {
          return {
            stock_id: movement.stock_id,
            ubicacion: movement.ubicacion,
          };
        });

      if (dataToSave.length == 0) {
        this.$refs.SweetAlert.showWarning("No hay cambios para guardar");
        return;
      }

      this.$refs.SweetAlert.showConfirmSimple2(
        "",
        "¿Estás seguro de Guardar estos Datos?",
        "warning",
        "Guardar"
      ).then((result) => {
        if (result.value) {
          this.post({
            url: this.$store.getters.get__url + "/Inventario/saveUbicacion",
            token: this.$store.getters.get__token,
            params: {
              alma: this.selectedAlma,
              data: dataToSave,
            },
          })
            .then((response) => {
              if (response.statusCode == 200) {
                this.$refs.SweetAlert.showSuccess("Guardado Correctamente");
                this.mtdGetSave();
                this.mtdGetData();
              } else {
                this.$refs.SweetAlert.showError("No se pudo guardar");
              }
            })
            .catch((errors) => {
              this.$refs.SweetAlert.showError(errors);
            });
        }
      });
    },
    //Paginacion
    backPage() {
      this.selectPage = this.selectPage > 1 ? this.selectPage - 1 : 1;
    },
    nextPage() {
      this.selectPage =
        this.selectPage < this.stepPagination.length
          ? this.selectPage + 1
          : this.stepPagination.length;
    },
    selectedPage(page) {
      this.selectPage = page;
    },
    returnHome: function () {
      this.$emit("returnHome");
    },
  },
  filters: {
    formatDate(date) {
      return date != null ? moment(date).format("DD/MM/YYYY") : "-";
    },
    formatDateTime(dateTime) {
      return dateTime != null
        ? moment(dateTime).format("DD/MM/YYYY HH:mm")
        : "-";
    },
  },
};
</script>